(() => {
  const mounted=new WeakMap();
  const profiles={
    'smokey-party-jollof-rice':{selects:['Spicy Level','Choice of Meat','Stews and Sauces'],checks:['Accompaniment','Seafood','Extra Meat','Drinks']},
    'egusi-soup':{selects:['Spicy Level','Choice of Meat','Accompaniment'],checks:['Seafood','Extra Meat','Extra Fufu','Drinks']}
  };
  function optionalHref(root,state) {
    try {
      const form=document.getElementById(root.dataset.formId);
      const source=document.getElementById(root.dataset.productJsonId);
      if(!form||!source) return state.baseHref;
      const product=JSON.parse(source.textContent),profile=profiles[product.handle];
      if(!profile) return state.baseHref;
      const raw=String(form.querySelector('[name="quantity"]')?.value??''),quantity=Number(raw);
      if(!/^[1-9]\d*$/.test(raw)||!Number.isSafeInteger(quantity)) return state.baseHref;
      const details=[];
      const selected=form.querySelector('[name="id"]')?.value;
      const variant=product.variants?.find(v=>String(v.id)===String(selected));
      if(variant?.title&&variant.title!=='Default Title') details.push('Option: '+variant.title);
      const app=form.querySelector('#infiniteoptions-container');
      if(app) {
        for(const name of profile.selects) {
          const control=app.querySelector(`select[name="properties[${name}]"]`);
          const values=Array.from(control?.selectedOptions??[]).filter(o=>!o.disabled&&o.value).map(o=>o.textContent.trim());
          if(values.length) details.push(name+': '+values.join('; '));
        }
        for(const name of profile.checks) {
          const hidden=app.querySelector(`input[type="hidden"][name="properties[${name}]"]`);
          const group=hidden?.closest('fieldset');
          const values=Array.from(group?.querySelectorAll('input[type="checkbox"]')??[]).filter(e=>e.checked&&!e.disabled).map(e=>e.value.trim());
          if(values.length) details.push(name+': '+values.join('; '));
        }
      }
      if(!details.length&&quantity===1) return state.baseHref;
      const url=new URL(state.baseHref);
      if(url.protocol!=='https:'||url.hostname!=='wa.me'||url.pathname!=='/250784102706') return state.baseHref;
      const message=url.searchParams.get('text');
      if(!message) return state.baseHref;
      url.searchParams.set('text',message+'\nQuantity: '+quantity+(details.length?'\n'+details.join('\n'):''));
      return url.href;
    } catch {return state.baseHref;}
  }
  function refresh(root) {
    const state=mounted.get(root);
    if(!state) return;
    try {state.link.setAttribute('href',optionalHref(root,state));}
    catch { /* The original server-rendered href stays the contact fallback. */ }
  }
  function mount(root) {
    if(mounted.has(root)) return;
    const link=root.querySelector('a'),baseHref=link?.getAttribute('href');
    if(!link||!baseHref) return;
    mounted.set(root,{link,baseHref});
    link.addEventListener('click',()=>refresh(root));
    const form=document.getElementById(root.dataset.formId);
    form?.addEventListener('input',()=>refresh(root));
    form?.addEventListener('change',()=>refresh(root));
    if(form&&typeof MutationObserver!=='undefined') new MutationObserver(()=>refresh(root)).observe(form,{childList:true,subtree:true});
  }
  function mountAll(scope=document) {scope.querySelectorAll('[data-jollof-whatsapp-optional]').forEach(mount);}
  mountAll();
  document.addEventListener('shopify:section:load',e=>mountAll(e.target));
})();
